import { RootState } from 'store';
import { User } from 'types/users';

export const selectUserIsLoading = (state: RootState): boolean => state.users.isLoading;

export const selectUser = (state: RootState): User | null => state.users.user;
